import styled from 'styled-components'
import media from 'utils/media'
import { H4 } from 'components/Text'

export const EmptyDiv = styled.div`
  width: 100%;
  height: 50px;
`

export const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  margin-top: 78px;
  padding: 0 50px;
  max-width: 1024px;
  background-color: ${p => p.theme.colors.gray7};

  ${media.screen`
    margin-top: 0;
    padding: 0;
    width: 100%;
    max-width: 100%;
  `}
`

export const ButtonSection = styled(H4)`
  display: flex;
  z-index: 1;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  width: 100%;
  background-color: ${props => props.theme.colors.whitelabel};
  color: white;
  font-size: 15px;
  font-weight: 300;
  text-transform: none;

  &:hover {
    cursor: pointer;
  }
`

export const OrderNumber = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.whitelabel};
  font-size: 13px;
  font-weight: 300;
`

export const Price = styled.span`
  font-weight: 300;
`
